import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import axios from "axios";
import { environment } from "../../env";
import { Label } from "reactstrap";
import ErrorComponents from "../errorComponents/ErrorComponents";
import { useDispatch, useSelector } from "react-redux";
import { loaderAction, successModalToggle } from "../../redux/actions/Index";
import { useMemo } from "react";
import { useEffect } from "react";
import { ToWords } from 'to-words';
import { getBuildingAction, getGalaAction } from './../../redux/actions/Index';
import Table from './../Table';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PencilLine } from '@phosphor-icons/react';

function AddGalaModal({ button, data, onEdit, buildingListProp }, ...props) {
  const toWords = new ToWords();

  // ---------List of useState-------------------------------------------------------
  const [modal, setModal] = useState(false);
  const [btndis, setBtndis] = useState(false);
  const [errormessage, setErrormessage] = useState();
  const [carpetErrorMessage, setCarpetErrorMessage] = useState();
  const [filteredGala, setFilteredGala] = useState([]);
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [buildingDetails, setBuildingDetails] = useState();
  const [galaerrormessage, setGalaErrormessage] = useState();
  const [avail_area, setAvail_area] = useState();
  const [galatable, setGalatable] = useState([]);
  const [gala, setGala] = useState(false);
  const [EDIT, setEDIT] = useState(false);
  const [auto, setauto] = useState(true);
  const [availableArea, setAvailableArea] = useState()
  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  // --------------------------------------------------------------------------------
  const ID = data?.id
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const galaListt = useSelector((state) => state?.ModalReducer?.galaList);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);

  const dispatch = useDispatch();
  const toggle = () => { setModal(!modal); setAvail_area(); setEDIT(false) }

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  var selectedBuildingId = watch("building");
  // var selectedProjectId = watch("project");
  var selectedGalaBuiltupAreaId = watch("builtup_area");
  var selectedGala = watch("gala_no");
  var GalaCarpetArea = watch("carpet_area");

  const CancelButton = () => {
    toggle();
    setEDIT(false)
    reset();
    setErrormessage()
    setBtndis(false)
    setGala(false)
    setBuildingDetails();
    setCarpetErrorMessage();
  };

  const getBuildingData = () => {
    try {
      axios.get(`${environment.baseUrl}building/`).then(res => {
        let data = res.data.filter((data, i) => data?.project.id == userProject)
        dispatch(getBuildingAction(data));
        setFilterBuilding(data);
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFilterBuilding(buildingListProp)
  }, [buildingListProp])

  const getGalaData = () => {
    try {
      axios.get(`${environment.baseUrl}gala/`).then(res => {
        let data = res.data.filter((data, i) => data?.project.id == userProject)
        dispatch(getGalaAction(data));
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  const autoAreaCarpet = () => {
    if (selectedGalaBuiltupAreaId) {
      setValue('carpet_area', (selectedGalaBuiltupAreaId / 1.25).toFixed(2))
    }
  }

  const onSubmit = async (data) => {
    setBtndis(true);
    dispatch(loaderAction(true));
    data.available_area = data.builtup_area
    data.project = userProject
    try {
      await axios.post(`${environment.baseUrl}gala/`, data).then((form) => {
        if (form.data.code === 200) {
          dispatch(successModalToggle());
          setauto(!auto);
          dispatch(loaderAction(false));
          toggle();
          setEDIT(false)
          setBuildingDetails();
          getGalaData()
          getBuildingData();
          reset();
          setBtndis(false);
          setErrormessage();
          setGalaErrormessage("");
          setCarpetErrorMessage();
          setGala(false)
        } else if (form.data.code === 5005) {
          dispatch(loaderAction());
          setBtndis(false);
          toast.error(form.data.message, {
            position: toast.POSITION.TOP_CENTER
          });
        } else {
          dispatch(loaderAction(false));
          setBtndis(false);
        }
      });
    } catch (err) {
      dispatch(loaderAction(false));
      setBtndis(false);
      console.log(err);
    }
  };

  const EditSubmit = async (dataa) => {
    dispatch(loaderAction(true));
    setBtndis(true);
    dataa.project = userProject;
    if (dataa.builtup_area != data.builtup_area) {
      if (dataa.builtup_area > Number(data.builtup_area) - Number(data.available_area)) {
        dataa.available_area = Number(dataa.builtup_area) - Number(Number(data.builtup_area) - Number(data.available_area))
      } else {
        setErrormessage("Builtup Area Change is greate than the Sold Area")
        setBtndis(false)
        return
      }
    }
    dataa.carpet_area = Number(dataa.carpet_area).toFixed(2)
    dataa.builtup_area = Number(dataa.builtup_area).toFixed(2)
    try {
      await axios
        .put(`${environment.baseUrl}edit-gala/${ID}`, dataa)
        .then((form) => {
          if (form.data.code === 200) {
            getGalaData()
            getBuildingData()
            onEdit();
            setauto(!auto);
            dispatch(loaderAction(false));
            dispatch(successModalToggle());
            reset(data);
            toggle();
            setEDIT(false)
            setGala(false)
            setBtndis(false);
          } else if (form.data.code === 5005) {
            dispatch(loaderAction());
            setBtndis(false);
            toast.error(form.data.message, {
              position: toast.POSITION.TOP_CENTER
            });
          } else {
            setBtndis(false);
          }
        });
    } catch (err) {
      setBtndis(false);
      dispatch(loaderAction(false));
      console.log(err);
    }
  };

  const filterGala = async (project, building) => {
    if (!(project == undefined && building == undefined)) {
      const FilterGalaPayload = new FormData();
      FilterGalaPayload.append("project", project);
      FilterGalaPayload.append("building", building);
      const FilterGalaURL = `${environment.baseUrl}filter-gala/`;
      dispatch(loaderAction(true));
      try {
        var galaList = [];
        await axios
          .post(FilterGalaURL, FilterGalaPayload)
          .then((galaresponse) => {

            galaList.push(galaresponse.data.data);
            dispatch(loaderAction(false));
            galaresponse.data.data.map((newgalalist) => {
              galaList.push({
                label: newgalalist.gala_no,
                value: newgalalist.id,
              });
            });
          });
        setFilteredGala(galaList);
      } catch (err) {
        dispatch(loaderAction(false));
        console.log(err);
      }
    }
  };

  useMemo(() => {
    if (userProject) {
      var projectBuilding = buildingList?.filter(
        (filterBuilding) => filterBuilding.project.id == userProject
      );
      projectBuilding?.sort((a, b) => (a.building_no > b.building_no) ? 1 : ((b.building_no > a.building_no) ? -1 : 0))
      setFilterBuilding(projectBuilding);
    }
  }, [EDIT]);

  useMemo(() => {
    if (GalaCarpetArea) {
      if (Number(GalaCarpetArea) > Number(selectedGalaBuiltupAreaId)) {
        setCarpetErrorMessage(`${GalaCarpetArea} is greater than ${selectedGalaBuiltupAreaId}`);
        setBtndis(true)
      }
      else {
        setBtndis(false)
        setCarpetErrorMessage('');
      }
    }
  }, [GalaCarpetArea]);

  useMemo(() => {
    if (userProject && selectedBuildingId) {
      if (typeof selectedBuildingId === "object") {
        filterGala(userProject, selectedBuildingId?.id);
      } else {
        filterGala(userProject, selectedBuildingId);
      }
    }
    if (selectedBuildingId == "") {
      setBuildingDetails();
    }
  }, [EDIT]);

  useMemo(() => {
    if (selectedBuildingId) {
      setGala(true)
      const selectedBuildingDetails = buildingList?.filter((building) => building.id == selectedBuildingId);

      let createdGala = 0
      filteredGala[0]?.map((item) => { createdGala += parseInt(item.builtup_area) });

      if (selectedBuildingDetails?.length > 0) {
        const totalbuildingbuiltup = selectedBuildingDetails[0]?.area_builtup - createdGala
        setBuildingDetails(`Total area: ${selectedBuildingDetails[0]?.area_builtup}, Available area: ${data?.building?.available_area}`)
        setAvailableArea(Math.floor(data?.building?.available_area))
        setAvail_area(totalbuildingbuiltup)
        if (selectedGalaBuiltupAreaId > (totalbuildingbuiltup)) {
          if (button == 'edit') {
            const availableArea = Number(selectedBuildingDetails[0]?.available_area) + Number(data?.builtup_area)
            if (availableArea >= selectedGalaBuiltupAreaId) {
              setBtndis(false)
              setErrormessage()
            } else {
              setErrormessage(`${selectedGalaBuiltupAreaId} is greater then ${totalbuildingbuiltup}`)
              setBtndis(true)
            }
          } else {
            setErrormessage(`${selectedGalaBuiltupAreaId} is greater then ${totalbuildingbuiltup}`)
            setBtndis(true)
          }
        }
        else {
          setBtndis(false)
          setErrormessage()
        }
        if (galaListt != undefined) {

          var Galas = galaListt.filter((gala) => gala.building.id == selectedBuildingId)
          setGalatable(Galas)
        }
      }
    }
  }, [EDIT]);

  useMemo(() => {
    if (EDIT == false) {
      const selectedGalaDetails = filteredGala[0]?.filter((gala) => gala.gala_no == selectedGala);
      if (selectedGalaDetails?.length > 0) {
        setGalaErrormessage("This Gala is already created...");
      }
      else {
        setGalaErrormessage("");
      }
    } else {
      return
    }
  }, [selectedGala])

  useEffect(() => {

  }, [buildingList])

  useEffect(() => {
    reset({
      "building": data?.building?.id,
      "builtup_area": data?.builtup_area,
      "carpet_area": data?.carpet_area,
      "gala_no": data?.gala_no,
      "project": data?.project?.id,
    })
  }, [buildingDetails])

  const GalaTable = (buildingID) => {
  }

  const columns = [
    {
      name: 'Gala No',
      selector: row => Number(row.gala_no),
      sortable: true,
      style: {
        fontSize: "4rem",
        fontWeight: 700,
      }
    },
    {
      name: 'Builtup Area',
      selector: row => (row.builtup_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "4rem",
        fontWeight: 700,
      }
    },
    {
      name: 'Carpet Area',
      selector: row => (row.carpet_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "4rem",
        fontWeight: 700,
      }
    }
  ];

  return (
    <>
      {button === 'edit' ?
        <>
          <button
            onClick={() => {
              toggle();
              setEDIT(true)
            }}
            className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
          </button>
        </>
        :
        <Button
          onClick={() => {
            setEDIT(false)
            toggle()
          }}
          className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
        >
          <span className="fs-2 d-flex gap-3 title-font-600 ps-2  pe-2">
            Create Gala
          </span>
        </Button>}
      <Modal
        className="border-0"
        isOpen={modal}
        toggle={props.toggle}
        size="lg"
        centered
      >
        <ModalHeader className="bg-base-color ">
          {button === 'edit' ? <span className="title-font-700 fs-36 text-base-white">
            Edit Gala
          </span>
            : <span className="title-font-700 fs-36 text-base-white">
              Create New Gala
            </span>
          }
        </ModalHeader>
        <Form onSubmit={
          button == "edit"
            ? handleSubmit(EditSubmit)
            : handleSubmit(onSubmit)
        }>
          <ModalBody className="bg-background-color px-5">
            <div className="row">
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Building no *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("building", { required: true, onChange: (e) => { GalaTable(e.target.value) } })}
                  >
                    <option value="">Building Number</option>
                    {filterBuilding?.sort((a, b) => a?.name?.localeCompare(b?.name))?.map((data, i) => {
                      return (
                        <option value={data.id} key={i}>{data.building_no}</option>
                      );
                    })}
                  </select>
                </div>
                {
                  errors.building && (
                    <ErrorComponents error={"Building no is required *"} />
                  )
                }

                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Gala No *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={1}
                    onKeyDown={preventNegativeValues}
                    placeholder="Enter Gala No..."
                    {...register("gala_no", { required: true, onChange: (e) => { if (parseFloat(e.target.value) == 0) { reset({ "gala_no": '' }); return false } } })}
                  />
                </div>
                {errors.gala_no && (<ErrorComponents error={"Gala No is required *"} />)}
                {galaerrormessage && <ErrorComponents error={galaerrormessage} />}
                <br />
              </div>
              {buildingDetails &&
                <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1 ">
                  <Label className="fs-4 title-font-500 mb-0 text-base-color opacity-0">
                    .
                  </Label>
                  <div className="mt-1  d-flex gap-3"><label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{buildingDetails}</label>
                  </div>
                  {
                    
                    <>
                      <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(availableArea)}</span></small>
                      <br />
                    </>
                  }
                </div>}
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Builtup Area *
                </Label>
                <br />
                <div className="numberTextSuffix">
                  <div className="mt-1  d-flex gap-3">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Enter Builtup Area...."
                      {...register("builtup_area", {
                        required: true,
                        onBlur: autoAreaCarpet
                      })}
                    />
                  </div>
                </div>
                {
                  selectedGalaBuiltupAreaId &&
                  <>
                    <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(selectedGalaBuiltupAreaId)}</span></small>
                    <br />
                  </>
                }
                {errors.builtup_area && (
                  <ErrorComponents error={" Builtup Area is required *"} />
                )}
                {errormessage && <ErrorComponents error={errormessage} />}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Carpet Area *
                </Label>
                <br />
                <div className="numberTextSuffix">
                  <div className="mt-1  d-flex gap-3">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      maxLength={4}
                      placeholder="Enter Carpet Area..."
                      {...register("carpet_area", { required: true })}
                    />
                  </div>
                </div>
                {
                  GalaCarpetArea &&
                  <>
                    <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(GalaCarpetArea)}</span></small>
                    <br />
                  </>
                }
                {errors.carpet_area && (
                  <ErrorComponents error={"Carpet Area is required *"} />
                )}
                {carpetErrorMessage && (
                  <ErrorComponents error={carpetErrorMessage} />
                )}

                <br />
              </div>
            </div>
            {gala &&
              <div className="bg-white py-4 px-4  rounded-5">
                {galatable.length > 0 ?
                  <div className="">
                    <div className=''>
                      <h3 className='mb-3 title-font-600 '>Previous Gala's </h3>
                    </div>
                    <Table columns={columns} data={galatable} />
                  </div>
                  :
                  <h3 className='title-font-bold text-base-color '> No Previous Galas Available </h3>}
              </div>}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
              onClick={CancelButton}
            >
              <span className="fs-4 d-flex gap-3 title-font-600 px-3">
                Cancel
              </span>
            </Button>{" "}
            <Button
              className="border-radius-7 p-3 d-flex align-items-center buttons"
              disabled={errormessage || galaerrormessage || btndis}
            >
              <span className="fs-4 d-flex gap-3 title-font-600 px-3">{button == 'edit' ? "Save" : "Create"}</span>
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default AddGalaModal;
